/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import icecream from '../../assets/projects/react-icecream.png';
import shoppingCart from '../../assets/projects/shopping-app-with-react-and-redux-responsive.png';
import ticTacToe from '../../assets/projects/tic-tac-toe-desktop.png';
import weatherDashboard from '../../assets/projects/weather-dashboard-desktop.png';
import wp_custom_theme from '../../assets/projects/wp-custom-theme.png';
import ProjectCards from '../../components/ProjectCards/ProjectCards';

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          Show case of <strong className="purple">Personal work </strong>
          (Learning Purpose)
        </h1>
        <p style={{ color: 'white' }}>
          Here are a few projects I've developed personally for learning
          purposes.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          <Col md={6} className="project-card">
            <ProjectCards
              imgPath={weatherDashboard}
              isBlog={false}
              title="Weather Dashboard App"
              description="This app will provide the weather information. For getting the weather information, user should have allow the browser to get the location lattitude and longitude information. It should be done only first time visit. It is safe, I have used Javascript GEOLOCATION API to solve this task. User can also find weather information from the search list."
              link="https://weather-dashboard-using-react-2025.vercel.app/"
              code_link="https://github.com/Prasanto19/weather-dashboard-using-react-2025"
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCards
              imgPath={ticTacToe}
              isBlog={false}
              title="Tic-Tac-Toe Game"
              description="Two people can play this game. If the game found the winner, it will announce the winner name and end the game. It's a practice project , that's why I also added a option so that any one can go back to his/her previous move and change his/her move."
              link="https://tic-tac-toe-using-react-2025.vercel.app/"
              code_link="https://github.com/Prasanto19/tic-tac-toe-using-react"
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={shoppingCart}
              isBlog={false}
              title="Shopping-app-with-react-and-redux"
              description="This is a shopping app UI where you can order from limited number of stocks. This app is implemented by react and redux.I implemented Tailwind CSS for responsive design."
              link="https://shopping-app-with-react-and-redux.netlify.app"
              code_link="https://github.com/Prasanto19/shopping-app-with-react-and-redux"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={wp_custom_theme}
              isBlog={false}
              title="Wordpress-custom-theme"
              description="This is a custom theme built for wordpress site where I tried to use all the necessary functionalities and features."
              link="https://wp-custom-theme.netlify.app/"
              code_link="https://github.com/Prasanto19/wordpress-Custom_theme"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCards
              imgPath={icecream}
              isBlog={false}
              title="Ice-cream order app"
              description="This is a beautiful ice cream builder ui. You can select your favourite ice-cream to order and a beautiful dynamic ice-cream will be build according to your choice. It's a self developed personal project created using create-react-app with react.js."
              link="https://beautiful-ice-cream-builder-ui.netlify.app/"
              code_link="https://github.com/Prasanto19/react-beautiful-ice-cream-builder-ui"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
